module.exports = __webpack_public_path__ + "static/media/cvbox.9f4b76f4.png";